module.exports = __webpack_public_path__ + "media/images/menu/sagitta-67d0854fce7e1e03ca28be181ce7eeff.jpg";